import { IDemoFlow, proposal, step } from './types';
import { DEMO_UAT_RECORDS } from './uatRecords';

// Reward, Rule and Loyalty: the backend already created the record, so Open in builder edits it and
// the save is reported with `handoff_result`.

const draftFlow = (
  id: string,
  prompt: string,
  type: string,
  label: string,
  entity: string,
  record: { id: number; name: string },
  noun: string
): IDemoFlow => ({
  id,
  prompt,
  reply: now => ({
    outcome: 'action_proposed',
    answer: `I created the draft ${noun} ${record.name} (#${record.id}). Review it in the builder.`,
    action: proposal(
      step(type, label, {
        entity,
        id: record.id,
        name: record.name,
        state: 'draft',
        subtype: null
      }),
      now,
      {
        buttons: [{ id: 'open_builder', label: 'Open in builder' }],
        builder: { form: `${entity}_edit`, prefill: null }
      }
    )
  })
});

export const REWARD_RULE_LOYALTY_FLOWS: IDemoFlow[] = [
  draftFlow(
    'reward-create',
    'Create a reward Free Coffee',
    'create_reward',
    'Create reward',
    'reward',
    DEMO_UAT_RECORDS.reward,
    'reward'
  ),
  draftFlow(
    'rule-create',
    'Create a rule Double points weekend',
    'create_transaction_rule',
    'Create rule',
    'rule',
    DEMO_UAT_RECORDS.rule,
    'rule'
  ),
  draftFlow(
    'loyalty-create',
    'Create a loyalty programme Gold Club',
    'create_loyalty_program',
    'Create loyalty programme',
    'loyalty_program',
    DEMO_UAT_RECORDS.loyaltyProgram,
    'loyalty programme'
  )
];
